// extracted by mini-css-extract-plugin
export default {"info":"MsVSh","infoRow":"G9L0A","item":"XGsyJ","title":"EQW5m","text":"rHUN0"};